// extracted by mini-css-extract-plugin
export default {"errorWrapper":"D2PzkvhaXfQb6ozwYyId","errorTitle":"Ut_TBNLbgoL1thwqtmJu","errorCode":"YF0nFDbQ4OG841bWjQTt"};